export default {
  path: '/avalista',
  component: () => import('./views/GuarantorWrapper.vue'),
  children: [{
    path: 'acordo',
    name: 'guarantor-agreement',
    component: () => import('./views/GuarantorAgreement.vue'),
  }, {
    path: 'aceito',
    name: 'guarantor-accepted',
    component: () => import('./views/GuarantorAccepted.vue'),
  }, {
    path: '*',
    component: () => import('@/views/NotFound.vue'),
  }],
};
